export default "__VITE_ASSET__BNS9XLan__"